// components/ThreadWindow.jsx
import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getSocket } from "../../socket/socket.js";
import Loading from "../../Loader/Loader.jsx";
import ThreadTypingIndicator from "./ThreadTypingIndicator.jsx";
import TypingIndicator from './TypingIndicator.jsx';
import '../chatcss/Thread.css'
import { Box, Typography, Chip, Stack, Divider, Button } from '@mui/material';

// Redux imports
import {
  fetchThreadConversation,
  sendThreadMessage,
  setCurrentThread,
  clearCurrentThread,
  receiveThreadMessage,
  setThreadTyping,
  clearThreadTyping,
  selectCurrentThread,
  selectThreadLoading,
  selectThreadTyping
} from '../../slice/threadSlice.jsx';
const ThreadWindow = ({ messageId: propMessageId }) => {
  const dispatch = useDispatch();
  const { messageId: paramMessageId } = useParams();
  
  // Use prop messageId if provided (for modal), otherwise use URL param (for standalone page)
  const messageId = propMessageId || paramMessageId;
  
  // Redux state
  const user = useSelector((state) => state.auth.user);
  const currentThread = useSelector(selectCurrentThread);
  const loading = useSelector(selectThreadLoading);
  
  // Local state
  const [isConnected, setIsConnected] = useState(false);
  const [threadInput, setThreadInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [otherUsersTyping, setOtherUsersTyping] = useState([]);
  const typingTimeoutRef = useRef(null);
  const messagesContainerRef = useRef(null);
  const socket = getSocket();
  
  // Get typing indicators from Redux as fallback/supplement to local state
  const reduxTyping = useSelector(selectThreadTyping(currentThread?.threadId)) || {};
  
  console.log('Current thread:', currentThread);
  
  // Auto-scroll to bottom when messages change
  useEffect(() => {
    if (currentThread?.messages?.length > 0 && messagesContainerRef.current) {
      setTimeout(() => {
        messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
      }, 100);
    }
  }, [currentThread?.messages]);
  



  useEffect(() => {
    const socket = getSocket();
    const ReadMessage = (data) => {
      console.log("message read by", user)

      socket.emit("readthreadconversation", data);
    };

    const messages = currentThread?.messages || [];

    if (messages.length > 0) {
      const unreadFromOthers = messages.filter((msg) => {
        const senderId = msg?.sender?._id || msg?.sender;
        return !msg.isRead && senderId !== user.id;
      });

      const unreadFromItself = messages.filter((msg) => {
        const receiverId = msg?.receiver?._id || msg?.receiver;
        return !msg.isRead && receiverId === user.id;
      });

      if (unreadFromOthers.length > 0) {
        const message_ids = unreadFromOthers.map((msg) => msg._id);
        ReadMessage({ message_ids, user,mainThreadId: messageId });
      }

      if (unreadFromItself.length > 0) {
        const message_ids = unreadFromItself.map((msg) => msg._id);
        ReadMessage({ message_ids, user,mainThreadId: messageId });
      }
    }
  }, [currentThread?.messages]);






  useEffect(() => {
    if (messageId) {
      dispatch(fetchThreadConversation(messageId));
    }
    
    return () => {
      dispatch(clearCurrentThread());
    };
  }, [messageId, dispatch]);
    
  
  // Handle typing indicators
  const handleTypingStart = () => {
    if (!socket || !currentThread?.threadId || isTyping) return;
    
    setIsTyping(true);
    dispatch(setThreadTyping({
      threadId: currentThread.threadId,
      userId: user.id,
      senderName: user.firstName || user.userName || 'Someone',
      isTyping: true
    }));
    
    socket.emit('startThreadTyping', {
      threadId: currentThread.threadId,
      userId: user.id,
      senderName: user.firstName || user.userName || 'Someone'
    });
    
    // Auto stop typing after 3 seconds of inactivity
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }
    typingTimeoutRef.current = setTimeout(() => {
      handleTypingStop();
    }, 3000);
  };
  
  const handleTypingStop = () => {
    if (!socket || !currentThread?.threadId || !isTyping) return;
    
    setIsTyping(false);
    dispatch(clearThreadTyping({
      threadId: currentThread.threadId,
      userId: user.id
    }));
    
    socket.emit('stopThreadTyping', {
      threadId: currentThread.threadId,
      userId: user.id,
      senderName: user.firstName || user.userName || 'Someone'
    });
    
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
      typingTimeoutRef.current = null;
    }
  };
  useEffect(() => {
    
        if (socket?.connected) {
          setIsConnected(true);
        } else {
          setIsConnected(false);
        }
    
        // Optional: handle live changes
        socket?.on("connect", () => setIsConnected(true));
        socket?.on("disconnect", () => {
          console.log("therd disconnect")
          setIsConnected(false)});
    
        return () => {
          socket?.off("connect");
          socket?.off("disconnect");
        };
      }, [socket]);
    

    // Socket event listeners
    useEffect(() => {
      if (!socket) return;
      
      const handleReceiveThreadMessage = (message) => {
        console.log('🎯 Received thread message:', message);
        dispatch(receiveThreadMessage(message));
        
        // Also fetch updated conversation to ensure consistency
 
          dispatch(fetchThreadConversation(messageId));
      
      };
      
      const handleThreadTyping = (data) => {
        console.log('👀 Thread typing event:', data);
        
        const isForCurrentThread = data.threadId === currentThread?.threadId;
        const isFromOtherUser = data.userId !== user.id;
        
        if (isForCurrentThread && isFromOtherUser) {
          console.log('✅ Adding thread typing indicator');
          
          // Local UI update (kept for inline display)
          setOtherUsersTyping(prev => {
            const filtered = prev.filter(u => u.userId !== data.userId);
            return [...filtered, {
              userId: data.userId,
              senderName: data.senderName,
              timestamp: Date.now()
            }];
          });
          
          // ALSO update Redux so shared indicators render
          dispatch(setThreadTyping({
            threadId: data.threadId,
            userId: data.userId,
            senderName: data.senderName,
            isTyping: true
          }));
        }
      };
      
      const handleThreadTypingStop = (data) => {
        console.log('✋ Thread typing stop:', data);
        
        const isForCurrentThread = data.threadId === currentThread?.threadId;
        const isFromOtherUser = data.userId !== user.id;
        
        if (isForCurrentThread && isFromOtherUser) {
          console.log('✅ Removing thread typing indicator');
          
          // Remove typing user (local)
          setOtherUsersTyping(prev => 
            prev.filter(u => u.userId !== data.userId)
          );
          
          // ALSO update Redux to clear typing
          dispatch(clearThreadTyping({
            threadId: data.threadId,
            userId: data.userId
          }));
        }
      };
  
      socket.on("receiveThreadMessage", handleReceiveThreadMessage);
      socket.on("threadTyping", handleThreadTyping);
      socket.on("threadTypingStop", handleThreadTypingStop);
      
      return () => {
        socket.off("receiveThreadMessage", handleReceiveThreadMessage);
        socket.off("threadTyping", handleThreadTyping);
        socket.off("threadTypingStop", handleThreadTypingStop);
      };
    }, [socket, dispatch, user.id]);
  

  const handleSendThreadMessage = async (e) => {
    e?.preventDefault();
    
    if (!threadInput.trim() || !currentThread?.threadId) return;
    
    // Stop typing when sending message
    handleTypingStop();
    
    // Send via Redux thunk
    dispatch(sendThreadMessage({
      threadId: currentThread.threadId,
      content: threadInput.trim(),
      userId: user.id
    }));
    

     dispatch(fetchThreadConversation(messageId));
    setThreadInput("");
    
    // Auto-scroll after sending (small delay to ensure message appears)
    setTimeout(() => {
      if (messagesContainerRef.current) {
        messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
      }
    }, 200);
  };
  
  // Cleanup typing on unmount
  useEffect(() => {
    return () => {
      if (isTyping) {
        handleTypingStop();
      }
    };
  }, [currentThread?.threadId]);
  
  if (!isConnected) {
    return <Loading />;
  }
  
  if (loading.fetchingConversation) {
    return <Loading />;
  }
  
  if (!currentThread) {
    return (
      <div className="empty-thread">
        <h1>Thread not found</h1>
      </div>
    );
  }
  return (
    <Box sx={{ 
      height: '100%',
      display: 'flex', 
      flexDirection: 'column',
      bgcolor: '#f8fafc',
      overflow: 'hidden'
    }}>
      {/* Thread Header */}
      <Box sx={{
        p: 3,
        borderBottom: '1px solid',
        borderColor: 'divider',
        bgcolor: 'white',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}>
        {/* <Stack direction="row" alignItems="center" spacing={2}>
          <Box sx={{
            p: 1,
            borderRadius: 2,
            bgcolor: 'primary.50',
            border: '1px solid',
            borderColor: 'primary.200'
          }}>
            <Typography variant="h6" sx={{ color: 'primary.main', fontWeight: 700, m: 0 }}>
              🧵 Thread
            </Typography>
          </Box>
          
          {currentThread?.threadId && (
            <Chip 
              label={`ID: ${currentThread.threadId.slice(-8)}`}
              size="small"
              variant="outlined"
            />
          )}
        </Stack> */}
      </Box>

      {/* Original Message Card */}
      {currentThread?.mainMessage && (
        <Box sx={{ p: 3, bgcolor: 'white', borderBottom: '1px solid', borderColor: 'divider' }}>
          <Box sx={{
            p: 3,
            borderRadius: 3,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            position: 'relative',
            overflow: 'hidden',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              bgcolor: 'rgba(0,0,0,0.1)',
              borderRadius: 3
            }
          }}>
            <Stack direction="row" alignItems="flex-start" spacing={2} sx={{ position: 'relative', zIndex: 1 }}>
              <Box sx={{
                width: 48,
                height: 48,
                borderRadius: '50%',
                bgcolor: 'rgba(255,255,255,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.2rem',
                fontWeight: 'bold'
              }}>
                {currentThread.mainMessage.sender.firstName?.[0]?.toUpperCase() || '?'}
              </Box>
              
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'white', mb: 0.5 }}>
                  {currentThread.mainMessage.sender.firstName}
                </Typography>
                <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.95)', mb: 1, lineHeight: 1.5 }}>
                  {currentThread.mainMessage.content}
                </Typography>
                <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                  {new Date(currentThread.mainMessage.createdAt).toLocaleString(undefined, {
                    dateStyle: 'medium',
                    timeStyle: 'short',
                  })}
                </Typography>
              </Box>
            </Stack>
          </Box>
        </Box>
      )}
      
      {/* Thread Info Panel */}
      <Box sx={{ p: 3, bgcolor: 'white' }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, color: 'text.primary', display: 'flex', alignItems: 'center', gap: 1 }}>
            💬 Discussion
            {isTyping && (
              <Chip
                label="You're typing..."
                size="small"
                color="info"
                variant="filled"
                sx={{ 
                  fontSize: '0.75rem',
                  animation: 'pulse 1.5s infinite',
                  '@keyframes pulse': {
                    '0%': { opacity: 1 },
                    '50%': { opacity: 0.7 },
                    '100%': { opacity: 1 }
                  }
                }}
              />
            )}
          </Typography>
        </Stack>

        {/* Participants */}
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }} flexWrap="wrap">
          <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 600, minWidth: 'fit-content' }}>
            👥 Participants:
          </Typography>
          {(() => {
            const names = Array.from(new Set(
              (currentThread?.allowed || []).map((allowed) => {
                const u = allowed?.user;
                if (u && typeof u === 'object') return u.firstName || u.name || 'Unknown';
                const idStr = (allowed?.user && allowed.user.toString && allowed.user.toString()) || '';
                return `User ${idStr.slice(-4) || 'Unknown'}`;
              })
            ));
            return names.length ? names.map((n) => (
              <Chip
                key={n}
                label={n}
                size="small"
                sx={{ 
                  bgcolor: 'primary.50',
                  color: 'primary.main',
                  fontWeight: 600,
                  '&:hover': { bgcolor: 'primary.100' }
                }}
              />
            )) : <Typography variant="caption" sx={{ color: 'text.disabled' }}>No participants</Typography>;
          })()}
        </Stack>

        {/* Live Typing Indicators */}
        {(() => {
          const localTypingUsers = otherUsersTyping;
          const reduxTypingUsers = Object.values(reduxTyping).filter(user => user.isTyping && user.senderName);
          const names = Array.from(new Set([
            ...localTypingUsers.map(u => u.senderName),
            ...reduxTypingUsers.map(u => u.senderName)
          ]));
          
          if (names.length === 0) return null;
          
          return (
            <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap">
              <Typography variant="body2" sx={{ color: 'success.main', fontWeight: 600, minWidth: 'fit-content' }}>
                ✍️ Typing:
              </Typography>
              {names.map((name) => (
                <Chip
                  key={name}
                  label={name}
                  size="small"
                  color="success"
                  variant="filled"
                  sx={{
                    animation: 'pulse 1.5s infinite',
                    '@keyframes pulse': {
                      '0%': { opacity: 1 },
                      '50%': { opacity: 0.7 },
                      '100%': { opacity: 1 }
                    }
                  }}
                />
              ))}
            </Stack>
          );
        })()}
      </Box>
      
      {/* Messages Container */}
      <Box sx={{ 
        flex: 1, 
        bgcolor: '#f8fafc',
        p: 2,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Typography variant="subtitle2" sx={{ 
          color: 'text.secondary', 
          fontWeight: 600, 
          mb: 2,
          px: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          💭 {currentThread?.messages?.length || 0} Replies
        </Typography>
        
        <Box 
          ref={messagesContainerRef}
          sx={{ 
            flex: 1,
            overflowY: 'auto',
            pr: 1,
            '&::-webkit-scrollbar': {
              width: 6
            },
            '&::-webkit-scrollbar-thumb': {
              bgcolor: 'rgba(0,0,0,0.2)',
              borderRadius: 3
            }
          }}
        >
          <Stack spacing={2}>
            {(currentThread?.messages || []).map((msg, index) => (
              <Box 
                key={msg._id}
                sx={{
                  bgcolor: 'white',
                  borderRadius: 3,
                  p: 2.5,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                  border: '1px solid',
                  borderColor: 'divider',
                  position: 'relative',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    transform: 'translateY(-1px)'
                  }
                }}
              >
                <Stack direction="row" spacing={2}>
                  <Box sx={{
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    bgcolor: 'primary.50',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    color: 'primary.main',
                    border: '2px solid',
                    borderColor: 'primary.100',
                    flexShrink: 0
                  }}>
                    {msg.sender.firstName?.[0]?.toUpperCase() || '?'}
                  </Box>
                  
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'text.primary' }}>
                        {msg.sender.firstName}
                      </Typography>
                      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        #{index + 1}
                      </Typography>
                    </Stack>
                    
                    <Typography variant="body2" sx={{ 
                      color: 'text.secondary',
                      lineHeight: 1.6,
                      wordBreak: 'break-word'
                    }}>
                      {msg.content}
                    </Typography>
                    
                    <Typography variant="caption" sx={{ 
                      color: 'text.disabled',
                      mt: 1,
                      display: 'block'
                    }}>
                      {new Date(msg.createdAt).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true })}
                    </Typography>
                  </Box>
                </Stack>
              </Box>
            ))}
            
            {(currentThread?.messages || []).length === 0 && (
              <Box sx={{ 
                textAlign: 'center', 
                py: 6,
                color: 'text.disabled'
              }}>
                <Typography variant="body2">
                  No replies yet. Be the first to respond! 💬
                </Typography>
              </Box>
            )}
          </Stack>
        </Box>
      </Box>
      
      {/* Reply Input */}
      <Box sx={{ 
        p: 3, 
        bgcolor: 'white',
        borderTop: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 -2px 8px rgba(0,0,0,0.06)'
      }}>
        <Box component="form" onSubmit={handleSendThreadMessage} sx={{ display: 'flex', gap: 2, alignItems: 'flex-end' }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, mb: 1, display: 'block' }}>
              Reply to thread
            </Typography>
            <Box sx={{
              position: 'relative',
              bgcolor: '#f8fafc',
              borderRadius: 3,
              border: '2px solid',
              borderColor: threadInput.trim() ? 'primary.main' : 'divider',
              transition: 'border-color 0.2s ease'
            }}>
              <Box
                component="textarea"
                value={threadInput}
                onChange={(e) => {
                  const newValue = e.target.value;
                  setThreadInput(newValue);
                  
                  console.log('🏠 Input changed. Value:', JSON.stringify(newValue), 'Trimmed length:', newValue.trim().length, 'Currently typing:', isTyping);
                  
                  // Start typing indicator when user starts typing
                  if (newValue.trim() && !isTyping) {
                    console.log('🟢 Should start typing indicator');
                    handleTypingStart();
                  } else if (!newValue.trim() && isTyping) {
                    console.log('🔴 Should stop typing indicator');
                    handleTypingStop();
                  }
                }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    handleSendThreadMessage();
                  }
                }}
                placeholder="Type your reply here..."
                disabled={loading.sendingMessage}
                sx={{
                  width: '100%',
                  minHeight: 80,
                  maxHeight: 200,
                  p: 2,
                  border: 'none',
                  outline: 'none',
                  bgcolor: 'transparent',
                  resize: 'vertical',
                  fontFamily: 'inherit',
                  fontSize: '0.9rem',
                  lineHeight: 1.5,
                  '&::placeholder': {
                    color: 'text.disabled'
                  }
                }}
              />
              
              {threadInput.trim() && (
                <Typography variant="caption" sx={{
                  position: 'absolute',
                  bottom: 8,
                  right: 12,
                  color: 'text.disabled'
                }}>
                  Press Enter to send
                </Typography>
              )}
            </Box>
          </Box>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Button
              type="submit"
              variant="contained"
              disabled={!threadInput.trim() || loading.sendingMessage}
              sx={{
                minWidth: 120,
                height: 48,
                borderRadius: 3,
                fontWeight: 600,
                bgcolor: 'primary.main',
                '&:hover': {
                  bgcolor: 'primary.dark'
                },
                '&:disabled': {
                  bgcolor: 'action.disabled'
                }
              }}
            >
              {loading.sendingMessage ? (
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Box sx={{ 
                    width: 16, 
                    height: 16, 
                    border: '2px solid currentColor',
                    borderTopColor: 'transparent',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    '@keyframes spin': {
                      '0%': { transform: 'rotate(0deg)' },
                      '100%': { transform: 'rotate(360deg)' }
                    }
                  }} />
                  <Typography variant="body2">Sending</Typography>
                </Stack>
              ) : (
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Typography variant="body2">Reply</Typography>
                  <Typography variant="body2">→</Typography>
                </Stack>
              )}
            </Button>
            
            <Typography variant="caption" sx={{ 
              color: 'text.disabled',
              textAlign: 'center',
              fontSize: '0.7rem'
            }}>
              {threadInput.length}/1000
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ThreadWindow;
